<template>
  <div class="box-hd" id='应用截图'>
    <h2 class="title">企业端（车修修）应用截图</h2>
  </div>
</template>

<script>
export default {};
</script>

<style>
.xm-plain-box .box-hd {
  position: relative;
  height: 58px;
  -webkit-font-smoothing: antialiased;
}
.xm-plain-box .box-hd .title {
  margin: 0;
  font-size: 22px;
  font-weight: 200;
  line-height: 58px;
  color: #333;
}

</style>